import {useRef, useState} from "react";
import DialogueHandler from "./DialogueHandler";

const useDialogue = <T>() => {

    const modal = useRef<DialogueHandler>(null);
    const [value, setValue] = useState<T>();

    const open = (value?: T) => {
        modal.current!.open();
        setValue(value)
    }

    const close = () => {
        modal.current!.close();
        setValue(undefined)
    }

    return {
        ref: modal,
        open: open,
        close: close,
        getValue: () => value
    }
}

export default useDialogue;